import { Box, MenuItem, TextField, Typography } from "@mui/material";
import { colors, MONTHS } from "./constants";

export default function AdjustmentFields({ month, year, onMonthChange, onYearChange }) {
  return (
    <Box sx={{ p: 2, mb: 2.5, borderRadius: 3, backgroundColor: colors.primaryLight }}>
      <Typography sx={{ fontSize: 13, fontWeight: 700, mb: 1.5 }}>
        Adjustment Period
      </Typography>

      <Box sx={{ display: "flex", gap: 1.5 }}>
        <TextField
          select
          fullWidth
          size="small"
          label="Month"
          value={month}
          onChange={(e) => onMonthChange(e.target.value)}
        >
          {MONTHS.map((m) => (
            <MenuItem key={m.value} value={m.value}>
              {m.label}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          fullWidth
          size="small"
          type="number"
          label="Year"
          value={year}
          onChange={(e) => onYearChange(e.target.value)}
        />
      </Box>
    </Box>
  );
}
